import React from 'react';
import Navigation from './components/Layout/Navigation';
import Footer from './components/Layout/Footer';
import Hero from './components/Hero/Hero';
import WhoWeWorkWith from './components/WhoWeWorkWith/WhoWeWorkWith';
import Services from './components/Services/Services';
import HowWeWork from './components/HowWeWork/HowWeWork';
import EngagementModels from './components/EngagementModels/EngagementModels';
import TechStack from './components/TechStack/TechStack';
import Quality from './components/Quality/Quality';
import About from './components/About/About';
import Contact from './components/Contact/Contact';

function App() {
  return (
    <div className="App">
      <Navigation />
      <main>
        <Hero />
        <WhoWeWorkWith />
        <Services />
        <HowWeWork />
        <EngagementModels />
        <TechStack />
        <Quality />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
